<template>
  <div
    id="privilege-information-Redemptions"
    class="form-custom"
  >
    <b-row class="redemptions-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-2"
        >
          <b-card-header>
            <span class="information-header">Redemptions</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div>
                    <label
                      for="redeem-limit"
                      class=""
                    >
                      Redeem Limit
                    </label>
                    <v-select
                      v-model="formData.RedeemLimit"
                      class="redeem-limit-container bg-dropdown"
                      :class="
                        formData.RedeemLimit ? 'redeem-limit-selected' : null
                      "
                      placeholder="--Select--"
                      :reduce="option => option.value"
                      :options="privilegeRedeemLimit"
                      :clearable="false"
                    />
                  </div>
                  <div class="mt-2">
                    <label
                      for="redeem-limit"
                      class=""
                    >
                      Redeem Mode
                    </label>
                    <v-select
                      v-model="formData.RedeemMode"
                      class="redeem-limit-container bg-dropdown"
                      :class="
                        formData.RedeemMode ? 'redeem-limit-selected' : null
                      "
                      placeholder="--Select--"
                      :reduce="option => option.value"
                      :options="privilegeRedeemMode.filter(o => o.value == 1)
                      "
                      :clearable="false"
                    />
                  </div>
                  <div>
                    <b-form-group
                      :label="formData.privilegeType != PRIVILEGE_TYPE.EXCHANGE ? 'Point Reference' : `Point Reference (Minimum: ${formData.ExchangeMinValue} Points)` "
                      label-for="'point-reference"
                      class="mt-2"
                    >
                      <b-form-input
                        v-if="formData.privilegeType != PRIVILEGE_TYPE.EXCHANGE"
                        id="point-reference"
                        v-model="formData.pointRef"
                        @input="$emit('onNumberInput', $event, 'pointRef')"
                      />
                      <input-spin
                        v-else
                        :mode="formData.ExchangeId == 0 ? 'disabled' : ''"
                        :numValue="formData.pointRef == 0 ? formData.ExchangeMinValue : formData.pointRef"
                        :addValue="formData.ExchangeStepValue"
                        :isInputDisabled="false"
                        @update-number="updatePointRefExchange($event,'pointRef')"
                      />
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      :label="'Value Reference'"
                      label-for="'value-reference"
                      class="mt-2"
                    >
                      <b-form-input
                        v-if="formData.privilegeType != PRIVILEGE_TYPE.EXCHANGE"
                        id="value-reference"
                        v-model="formData.ValueReference"
                        @input="
                          $emit('onNumberInput', $event, 'ValueReference')
                        "
                      />
                      <input-spin
                        v-else
                        v-model="formData.ValueReference"
                        :mode="formData.ExchangeId == 0 ? 'disabled' : ''"
                        :numValue="formData.ValueReference"
                        :addValue="formData.ExchangeStepValue"
                        :isInputDisabled="false"
                        @update-number="updatePointRefExchange($event,'valueRef')"
                      />
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      :label="'Reserve Time-Out'"
                      label-for="'reserve-time-out"
                    >
                      <b-form-input
                        id="reserve-time-out"
                        v-model="formData.ReserveTimeOut"
                        @input="
                          $emit('onNumberInput', $event, 'ReserveTimeOut')
                        "
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div>
                    <label
                      for="valid-from-date"
                      class="required"
                    >
                      Valid From
                    </label>
                    <div class="d-flex">
                      <div
                        class="col p-0 p-relative mr-2 redemptions-date-picker"
                      >
                        <calendar-picker-icon
                          class="icon-calendar bypass" 
                          :class="
                            formData.validFrom.date
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          :id="'valid-from-date'"
                          v-model="formData.validFrom.date"
                          class="form-control  bg-date"
                          :class="
                            formData.validFrom.date
                              ? 'date-selected'
                              : 'border-danger'
                          "
                          :config="flatpickrDateConfig"
                          placeholder="Start Date"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidFromDatePicker"
                          @on-change="onSelectValidFromDate"
                        />
                      </div>
                      <div class="col p-0 p-relative redemptions-date-picker">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            formData.validFrom.time
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="formData.validFrom.time"
                          class="form-control  bg-date"
                          :class="[
                            formData.validFrom.time
                              ? 'date-selected'
                              : 'border-danger',
                          ]"
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidFromTimePicker"
                          @on-change="onSelectValidFromTimePicker"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 mb-2">
                    <label
                      for="valid-from-to"
                      class="required"
                    >
                      Valid Through
                    </label>
                    <div class="d-flex">
                      <div
                        class="
                            col
                            p-0 p-relative
                            mr-2
                            redemptions-date-picker
                          "
                      >
                        <calendar-picker-icon
                          class="icon-calendar bypass"
                          :class="
                            formData.validThrough.date
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          :id="'valid-to-date'"
                          v-model="formData.validThrough.date"
                          class="form-control  bg-date"
                          :class="
                            formData.validThrough.date
                              ? 'date-selected'
                              : 'border-danger'
                          "
                          :config="flatpickrDateConfig"
                          placeholder="End Date"
                          required
                          autocomplete="off"
                        />
                      </div>
                      <div class="col p-0 p-relative redemptions-date-picker">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            formData.validThrough.time
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="formData.validThrough.time"
                          class="form-control  bg-date"
                          :class="
                            formData.validThrough.time
                              ? 'date-selected'
                              : 'border-danger'
                          "
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidThroughTimePicker"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue'
import flatPickr from 'vue-flatpickr-component'
import usePrivilegeInformation from '../../hooks/usePrivilegeInformation'
import InputSpin from "@/views/components/input-spin/InputSpin.vue";

export default {
  components: {
    vSelect,
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    InputSpin,
  },
  props: { formData: { type: Object, default: {} } },
  setup(props) {
    const {
      PRIVILEGE_TYPE,
      privilegeRedeemLimit,
      privilegeRedeemMode,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      updatePointRefExchange,
    } = usePrivilegeInformation(props)

    return {
      PRIVILEGE_TYPE,
      privilegeRedeemLimit,
      privilegeRedeemMode,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      updatePointRefExchange,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
@import '~@/assets/css/pages/privilege/privilege-information-redemptions.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
